import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenuAnaliytics = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M17.5391 2.16675H8.46079C4.51746 2.16675 2.16663 4.51758 2.16663 8.46092V17.5284C2.16663 21.4826 4.51746 23.8334 8.46079 23.8334H17.5283C21.4716 23.8334 23.8225 21.4826 23.8225 17.5392V8.46092C23.8333 4.51758 21.4825 2.16675 17.5391 2.16675Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.45337 20.4752C7.0092 20.4752 6.64087 20.1068 6.64087 19.6627V17.4202C6.64087 16.976 7.0092 16.6077 7.45337 16.6077C7.89754 16.6077 8.26587 16.976 8.26587 17.4202V19.6627C8.26587 20.1177 7.89754 20.4752 7.45337 20.4752Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 20.4751C12.5558 20.4751 12.1875 20.1067 12.1875 19.6626V15.1667C12.1875 14.7226 12.5558 14.3542 13 14.3542C13.4442 14.3542 13.8125 14.7226 13.8125 15.1667V19.6626C13.8125 20.1176 13.4442 20.4751 13 20.4751Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5466 20.4749C18.1025 20.4749 17.7341 20.1066 17.7341 19.6624V12.9241C17.7341 12.4799 18.1025 12.1116 18.5466 12.1116C18.9908 12.1116 19.3591 12.4799 19.3591 12.9241V19.6624C19.3591 20.1174 19.0016 20.4749 18.5466 20.4749Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3591 6.30515C19.3591 6.25098 19.3374 6.18598 19.3266 6.13181C19.3158 6.08848 19.3049 6.03431 19.2941 5.99098C19.2724 5.94765 19.2399 5.91515 19.2183 5.87181C19.1858 5.82848 19.1533 5.77431 19.1099 5.74181C19.0991 5.73098 19.0991 5.72015 19.0883 5.72015C19.0558 5.69848 19.0233 5.68765 18.9908 5.66598C18.9474 5.63348 18.8933 5.60098 18.8391 5.57931C18.7849 5.55765 18.7308 5.55765 18.6766 5.54681C18.6333 5.53598 18.6008 5.52515 18.5574 5.52515H15.3833C14.9391 5.52515 14.5708 5.89348 14.5708 6.33765C14.5708 6.78181 14.9391 7.15015 15.3833 7.15015H16.7374C14.1591 9.85848 10.9091 11.7651 7.25827 12.686C6.82494 12.7943 6.5541 13.2385 6.66244 13.6718C6.7491 14.0401 7.08494 14.2893 7.45327 14.2893C7.51827 14.2893 7.58327 14.2785 7.64827 14.2676C11.5158 13.3035 14.9716 11.2993 17.7341 8.46098V9.51181C17.7341 9.95598 18.1024 10.3243 18.5466 10.3243C18.9908 10.3243 19.3591 9.95598 19.3591 9.51181V6.33765C19.3591 6.32681 19.3591 6.31598 19.3591 6.30515Z",
			fill: "white"
		})
	]
});
export default SvgMenuAnaliytics;
